
import { Component, Prop, toNative, Vue, Watch } from 'vue-facing-decorator';
import ModalPopup from '@/components/Common/ModalPopup.vue';
import { NotificationItem } from '@/entities/Notification/NotificationItem';
import VueModalPopUp from '@/components/Common/VueModalPopUp.vue';
import { VueModalPopUpViewModel } from '@/entities/VueModalPopUpViewModel';
import NotificationEnum from '@/enums/NotificationEnum';
import { FetchData, Root } from '@/main';
import RemoveNotificationFeedback from '@/entities/Emits/Notification/RemoveNotificationFeedback';
@Component({
  components: {
    ModalPopup,
    VueModalPopUp,
  },
})
class NotificationResponseCounterAndReminder extends Vue {
  @Prop() private selectedNotificationItem!: NotificationItem;
  private localNotificationItem: NotificationItem = NotificationItem.createEmpty();
  private totalUsersFeedbacksCount = 0;
  private modalPopupVisible = false;
  private showCloseButton = true;
  private modalPopupContent = '';
  private modalPopupHeading = '';
  private modalPopupShowCancelButton = true;
  private modalPopupConfirmButtonText = '';
  private showVueModalPopUp = false;
  private sendReminderPopUpContent: VueModalPopUpViewModel = VueModalPopUpViewModel.createEmpty();
  private mounted() {
    this.localNotificationItem = Object.assign({},this.selectedNotificationItem);
    this.SetUserFeedbackCount();
    this.SetSendReminderPopUpContent();
  }
  private SetSendReminderPopUpContent() {
    this.sendReminderPopUpContent = new VueModalPopUpViewModel(
      this.$t('Dialogue.SendReminder').toString(),
      this.$t('Dialogue.SendReminderDescription',{remindersCount: this.localNotificationItem.CountOfRemainingRemindersToSend, reminderString: this.GetReminderString()}).toString(),
      false,
      '',
      this.$t('CancelButton').toString(),
      this.$t('Button.Send').toString(),
    );
  }
  // this helps in setting and updating the user feedback count which enables or disables the clear all responses options
  private SetUserFeedbackCount() {
    if(this.localNotificationItem.UserFeedback !==undefined) {
      this.totalUsersFeedbacksCount = this.localNotificationItem.UserFeedback.length;
    }
  }
  private IsSendReminderLinkDisabled() {
    return (this.localNotificationItem.IsPublished && this.localNotificationItem.RecipientCount !==0 && this.localNotificationItem.CountOfRemainingRemindersToSend !== 0 && this.localNotificationItem.NotificationFeedbacks !== this.localNotificationItem.RecipientCount);
  }
  private GetText() {
    return this.$t('Dialogue.HighCharts.ResposeSummreryText', {responseCount : this.localNotificationItem.NotificationFeedbacks, participantCount: this.localNotificationItem.RecipientCount});
  }
  private GetTotalCountOfReminder() {
    return this.$t('Dialogue.RemindersTotalCount',{remindersCount: this.localNotificationItem.CountOfRemainingRemindersToSend, reminderString: this.GetReminderString()});
  }
  private GetReminderString() {
    return this.localNotificationItem.CountOfRemainingRemindersToSend > 1 ? 's' : '';
  }
  private IsReminderLinkVisible() {
    if(this.localNotificationItem.QuestionnaireNotifications !== null && this.localNotificationItem.QuestionnaireNotifications !== undefined) {
      let countOfInformationDialogueItem = 0;
      this.localNotificationItem.QuestionnaireNotifications.forEach((item)=> {
        if(item.NotificationTypeId === NotificationEnum.InformationMessage) {
          countOfInformationDialogueItem++;
        }
      });
      return (this.localNotificationItem.QuestionnaireNotifications.length === countOfInformationDialogueItem);
    }
  }
  private ShowReminderPopUp() {
    if(this.IsSendReminderLinkDisabled()) {
      this.SetSendReminderPopUpContent();
      this.showVueModalPopUp = true;
    }
  }
  private CloseVueModelPopup() {
    this.showVueModalPopUp = false;
  }
  private SendReminderToParticipants() {
    // Api call for updating reminders;
    FetchData('/Notification/SendReminderToParticipants', JSON.stringify({
      notificationId: this.localNotificationItem.Id,
    }))
      .then((response)=> {
        if (response.Success === true) {
          this.localNotificationItem.CountOfRemainingRemindersToSend = response.remainingReminders;
          Root.emit('notification-show-overlay', true);
          Root.emit('update-reminder-count-of-notification-item',this.localNotificationItem.Id,response.remainingReminders);
        }
      })
      .catch(()=> {
        // console log to print error
      });
    this.showVueModalPopUp = false;
  }
  private ShowToolTip() {
    if(!this.localNotificationItem.IsPublished) {
      return this.$t('Dialogue.SendReminderUnpublishTooltip');
    }
    if(this.localNotificationItem.RecipientCount === 0) {
      return this.$t('Dialogue.SendReminderZeroParticipantTooltip');
    }
    if(this.localNotificationItem.NotificationFeedbacks === this.localNotificationItem.RecipientCount) {
      return this.$t('Dialogue.SendReminderAllParticipantsRespondedTooltip');
    }
  }
  private ConfirmClick(confirmed: boolean) {
    this.modalPopupVisible = false;
    if (confirmed) {
      if(this.localNotificationItem.IsSurvey) {
        this.ClearAllSurveyItemsResponses();
      } else {
        this.ClearAllDialogueItemResponses();
      }
    }
  }
  private IsClearAllResponsesDisabled() {
    return (this.totalUsersFeedbacksCount === 0 && this.localNotificationItem.NotificationFeedbacks === 0);
  }
  private ClearAllSurveyItemsResponses() {
    FetchData('/Notification/DeleteAllSurveyReposnes', JSON.stringify({
      surveyId: this.localNotificationItem.Id,
    }))
      .then((response)=> {
        if (response.Success === true) {
          this.localNotificationItem.NotificationFeedbacks = 0;
          Root.emit('notification-show-overlay', true);
          Root.emit('reload-sub-notification-detail',this.localNotificationItem);
        }
      })
      .catch(()=> {
        // console log to print error
      });
  }
  private ClearAllDialogueItemResponses() {
    FetchData('/Notification/DeleteAllReposne', JSON.stringify({
      notificationId: this.localNotificationItem.Id,
    }))
      .then((response) => {
        if (response.Success === true) {
          this.localNotificationItem.UserFeedback = [];
          Root.emit('notification-show-overlay', true);
          if (!this.localNotificationItem.IsSurvey) {
            Root.emit('reload-notification-detail');
          } else {
            Root.emit('reload-sub-notification-detail', this.localNotificationItem);
          }
          const removeFeedbacks: RemoveNotificationFeedback = RemoveNotificationFeedback.createEmpty();
          removeFeedbacks.Id = this.localNotificationItem.Id;
          Root.emit('notification-feedback-removed', removeFeedbacks);
        }
      })
      .catch(() => {
        // Log error if required
      });
  }
  private ClearAllResponseClicked() {
    if(!this.IsClearAllResponsesDisabled()) {
      this.showCloseButton = true;
      this.modalPopupContent = this.$t('Dialogue.ClearAllResponsesDescription').toString();
      this.modalPopupConfirmButtonText = this.$t('Button.Delete').toString();
      this.modalPopupVisible = true;
    }
  }
  @Watch('selectedNotificationItem',{deep: true})
  private CheckChangeInselectedNotificationItem(newVal: NotificationItem) {
    this.localNotificationItem = newVal;
    this.SetUserFeedbackCount();
  }
}
export default toNative(NotificationResponseCounterAndReminder);
